import React from "react";
import { Link } from "react-router-dom";
// Fluent UI
import {
  CommandBarButton,
  ContextualMenuItem,
  TooltipHost
} from "@fluentui/react";

// In order to get react-router-dom to work with the ContextualMenu.
const SubMenuItem = props => (
  <>
    {props.item.link ? (
      <Link to={props.item.link} className="unstyled-link">
        <ContextualMenuItem {...props} />
      </Link>
    ) : props.tooltip ? (
      <TooltipHost {...props.tooltip}>
        <ContextualMenuItem {...props} />
      </TooltipHost>
    ) : (
      <ContextualMenuItem {...props} />
    )}
  </>
);

const MenuItem = props => (
  <>
    {props.link !== undefined ? (
      <Link to={`${props.link}`}>
        <CommandBarButton {...props} />
      </Link>
    ) : props.tooltip ? (
      <TooltipHost {...props.tooltip}>
        <CommandBarButton {...props} />
      </TooltipHost>
    ) : (
      <CommandBarButton {...props} />
    )}
  </>
);

export { SubMenuItem, MenuItem };
